import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicePageShell from '../../components/ServicePageShell';
import AtoudaOlimAkademStatic from './AtoudaOlimAkademStatic';

const AtoudaOlimAkadem = () => (
  <ServicePageShell
    strapiApiId="service-atouda-olim-akademisatzia"
    defaultTitle="Atouda Olim et Akademisatzia"
    StaticFallback={AtoudaOlimAkademStatic}
  />
);

export default AtoudaOlimAkadem;
